import React, { useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from '@hooks/useTranslation'
import { selectPackageCodesList } from '@EUForms/selectors'
import CustomPopup from '@commonComponents/customPopup'
import PackageForm from '@EUForms/invoice/MerchandiseForms/PackageForm'
import RepeatableItemsContainer from '@containers/repeatableItemsContainer'
import List from '@commonComponents/List'
import { AddBtn } from '@commonComponents/AddBtn'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import { updateValidationErrors } from '../../AES_App/reducer/validationSlice'
import validate from 'validate.js'
import { useCurrentShipmentType } from '../../../components/hooks/useCurrentShipmentType'
import CopyRepElement from '@commonComponents/copyRepElement'
import MarkedDeleted from '../../DMS_App/formSections/items/markedDeleted'

const PackagingDocument = (props) => {
    const {
        invoiceId,
        merchandiseId,
        packagesList = [],
        isLoading,
        addItem,
        fieldPattern,
        createRepElemMsgStructure,
        invoiceIndex,
        itemIndex,
        disabled,
        isMerchandiseDisabled,
        isRFIDisabled=false,
        onMarkMerchandiseDocDelete,
        ...rest
    } = props
    const popup = useRef()
    const translate = useTranslation()

    return (
        <React.Fragment>
            {isLoading && <CustomLoader />}
            {packagesList?.length > 0 ? <span
                id={`packagesList-${invoiceId}-${merchandiseId}`}
                style={{
                    top: '50%',
                    position: 'relative',
                    margin: '0px 5px',
                    fontWeight: '800',
                    color: 'blue',
                    cursor: 'pointer'
                }}
                onClick={() => popup.current?.openPopup()}
            >
                +{packagesList?.length - 1}
            </span> : (
                <AddBtn
                    text='ADD'
                    size='mini'
                    className='addrepeatBtn'
                    onClick={() => addItem('packagesList')}
                    disabled={isMerchandiseDisabled}
                />
            )}
            <CustomPopup
                ref={popup}
                closeIcon
                onClose={() => popup.current?.closePopup()}
                content={true}
                className='C88 popupCustomPackaging'
                header={<div>{`PACKAGING`}</div>}
                description={<div>
                    {isLoading && <CustomLoader />}
                    <RepeatableItemsContainer
                        isLoading={isLoading}
                        addItem={addItem}
                        {...rest}
                        tableName='packagesList'
                        merchandiseId={merchandiseId}
                        reducerName='invoiceReducer'
                        translate={translate}
                        renderForm={(params) => <PackagingDocumentDetails
                            disabled={disabled}
                            fieldPattern={fieldPattern}
                            createRepElemMsgStructure={createRepElemMsgStructure}
                            invoiceIndex={invoiceIndex}
                            itemIndex={itemIndex}
                            isMerchandiseDisabled={isMerchandiseDisabled}
                            isRFIDisabled={isRFIDisabled}
                            onMarkMerchandiseDocDelete={onMarkMerchandiseDocDelete}
                            {...params}
                        />}
                        isAddDisabled={isMerchandiseDisabled}
                    />
                </div>}
            />
        </React.Fragment>
    )
}

export default PackagingDocument


export const PackagingDocumentDetails = (props) => {
    const {
        dataSource,
        fieldPattern,
        createRepElemMsgStructure,
        invoiceIndex,
        itemIndex,
        disabled,
        isMerchandiseDisabled,
        isRFIDisabled,
        onMarkMerchandiseDocDelete,
        ...rest
    } = props

    const packageTypeList = useSelector(selectPackageCodesList)
    const translate = useTranslation()
    const dispatch = useDispatch()

    const { isDisabled, version, isRFI } = useCurrentShipmentType()



    const packagesList = fieldPattern && fieldPattern()?.itemsTab?.packagesList

    const packagesListValidation = (pckgIdx, name, value, type, quantity, shippingMarks) => {


        const key1 = `invoice${invoiceIndex + 1}_lineItem${itemIndex + 1}_PACKAGE${pckgIdx + 1}_${name}`
        const key2 = `invoice${invoiceIndex + 1}_lineItem${itemIndex + 1}_PACKAGE${pckgIdx + 1}_quantity`
        const key3 = `invoice${invoiceIndex + 1}_lineItem${itemIndex + 1}_PACKAGE${pckgIdx + 1}_shippingMarks`


        let repElemErr

        if (name == 'type') {

            repElemErr = validate({ [name]: value, quantity: quantity, shippingMarks },
                { quantity: packagesList?.quantity, shippingMarks: packagesList?.shippingMarks, [name]: packagesList[name] }
            ) || {}

        } else {
            repElemErr = validate({ type: type, [name]: value },
                { type: packagesList?.type, [name]: packagesList[name] }
            ) || {}
        }

        repElemErr = createRepElemMsgStructure(repElemErr, translate("PACKAGE"), invoiceIndex, itemIndex, pckgIdx, translate)

        dispatch(updateValidationErrors({
            tabName: 'itemsTab',
            errors: { ...repElemErr },
            errorKeys: name == 'type' ? [key1, key2, key3] : [key1]
        }))
    }

    const renderItem = useCallback(
        (item, pckgIdx) => {
            const isPackageDocDisabled = (isMerchandiseDisabled||(isRFI&&item?.markDelete=='1')||null)
            return (
                <PackageForm
                    disabled={disabled}
                    dataSource={item}
                    key={item.id}
                    packageTypeList={packageTypeList}
                    pckgIdx={pckgIdx}
                    packagesListValidation={version === 'AES' ? packagesListValidation : null}
                    copyDocument={version === 'DMS' ? (translate) => (<CopyRepElement
                        translate={translate}
                        title='PACKAGING'
                        request={{ ...item, infoType: 'PACKAGING' }}
                        callback={rest?.copyData}
                        isFormDisabled={isRFI||isPackageDocDisabled||rest?.isDisabled||isDisabled}
                        tableName={rest?.tableName} />) : null}
                    {...rest}
                    isPackageDocDisabled={isPackageDocDisabled}
                    markedDeleted={isRFI ? (params) => <MarkedDeleted
                        label='_'
                        className='marked-deleted marked-deleted-label-hidden'
                        disabled={(isRFIDisabled||isMerchandiseDisabled)}
                        checked={isPackageDocDisabled}
                        onChange={
                            (e, data) => onMarkMerchandiseDocDelete(data, params)
                        }
                    /> : null}
                />
            )
        },
        [rest, packageTypeList]
    )

    return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}  